export default __webpack_public_path__ + "static/media/web.607d206d.png";